"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIDropdownDivider;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _HR = _interopRequireDefault(require("../elements/HR"));

var getClasses = function getClasses(className) {
  return (0, _classnames.default)('private-dropdown-divider', className);
};

function UIDropdownDivider(_ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  return _react.default.createElement(_HR.default, Object.assign({
    distance: "xs"
  }, rest, {
    className: getClasses(className)
  }));
}

UIDropdownDivider.displayName = 'UIDropdownDivider';
module.exports = exports.default;